import { Image, useTheme } from "@aws-amplify/ui-react";
import caninsoftLogo from '../images/caninsoft-logo.svg';

export function Header() {
  const { tokens } = useTheme();

  return (
    <Image
      alt="logo"
      src={caninsoftLogo} 
      padding={tokens.space.medium}
    />
  );
}
